// AMANI : mur de vidéos (bloc UNDR « PDP video wall », code repris tel quel)
(function () {
  if (customElements.get('undr-pdp-video-block')) return;
class UndrPdpVideoBlock extends HTMLElement {
    connectedCallback() {
      if (this.dataset.init) return;
      this.dataset.init = '1';
      var rail = this.querySelector('[data-undr-vwb-rail]');
      var fill = this.querySelector('[data-undr-vwb-fill]');
      if (!rail) return;
      var sync = function () {
        if (!fill) return;
        var max = rail.scrollWidth - rail.clientWidth;
        var frac = rail.scrollWidth ? rail.clientWidth / rail.scrollWidth : 1;
        var pos = max > 0 ? rail.scrollLeft / max : 0;
        fill.style.width = (frac * 100) + '%';
        fill.style.marginLeft = (pos * (1 - frac) * 100) + '%';
      };
      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
      var auto = this.dataset.autoplay === 'true';
      var mode = this.dataset.click || 'inline';
      var dialog = this.querySelector('[data-undr-vwb-dialog]');
      var dv = dialog ? dialog.querySelector('[data-undr-vwb-dialog-video]') : null;
      if (dialog) {
        var closeDlg = function () { dv.pause(); dialog.close ? dialog.close() : dialog.removeAttribute('open'); enPause.forEach(function (v) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }); enPause = []; };
        dialog.querySelector('[data-undr-vwb-close]').addEventListener('click', closeDlg);
        dialog.addEventListener('click', function (e) { if (e.target === dialog) closeDlg(); });
        dv.addEventListener('click', function () { if (dv.paused) dv.play(); else dv.pause(); });
        // AMANI : en grand on lit le mp4 (démarre en moins d'une seconde, le HLS met 2 à 3 s) ; jamais vide même si la vignette n'a pas encore chargé
        var srcOf = function (v) { return v.dataset.amSrc || v.currentSrc || (v.querySelector('source') || {}).src || v.src || ''; };
        var enPause = [];
        var current = 0;
        var showAt = function (i) {
          if (i < 0 || i >= videos.length) return;
          current = i;
          var src = srcOf(videos[i]); if (!src) return;
          if (dv.getAttribute('src') !== src) dv.setAttribute('src', src);
          dv.preload = 'auto'; dv.muted = false; var pm = dv.play(); if (pm && pm.catch) pm.catch(function () { dv.muted = true; dv.play(); });
          var prev = dialog.querySelector('[data-undr-vwb-prev]'), next = dialog.querySelector('[data-undr-vwb-next]');
          if (prev) prev.disabled = i === 0;
          if (next) next.disabled = i === videos.length - 1;
        };
        this.undrShowAt = showAt;
        var prevBtn = dialog.querySelector('[data-undr-vwb-prev]'), nextBtn = dialog.querySelector('[data-undr-vwb-next]');
        if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); showAt(current - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); showAt(current + 1); });
        dialog.addEventListener('keydown', function (e) { if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); showAt(current - 1); } if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); showAt(current + 1); } });
        var y0 = null, x0 = null;
        dialog.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; x0 = e.touches[0].clientX; }, { passive: true });
        dialog.addEventListener('touchend', function (e) { if (y0 === null) return; var dy = e.changedTouches[0].clientY - y0, dx = e.changedTouches[0].clientX - x0; y0 = null; if (Math.abs(dy) > 40 && Math.abs(dy) > Math.abs(dx)) showAt(dy < 0 ? current + 1 : current - 1); });
        var wheelLock = 0;
        dialog.addEventListener('wheel', function (e) { var now = Date.now(); if (now - wheelLock < 700 || Math.abs(e.deltaY) < 20) return; wheelLock = now; showAt(e.deltaY > 0 ? current + 1 : current - 1); }, { passive: true });
      }
      var videos = Array.prototype.slice.call(this.querySelectorAll('video'));
      var stopOthers = function (except) { videos.forEach(function (v) { if (v !== except && !v.paused && !auto) v.pause(); }); };
      var self = this;
      // AMANI : lecture auto seulement quand la vidéo est à l'écran ; le fichier ne se charge qu'à ce moment
      var lancer = function (v) {
        if (!v.getAttribute('src') && v.dataset.amSrc) v.setAttribute('src', v.dataset.amSrc);
        v.muted = true; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      };
      var obs = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) lancer(e.target); else if (!e.target.paused) e.target.pause(); });
      }, { rootMargin: '200px' }) : null;
      var vue = function (v) { if (obs) obs.observe(v); else lancer(v); };
      this.querySelectorAll('[data-undr-vwb-card]').forEach(function (card) {
        var video = card.querySelector('video');
        if (!video) return;
        if (auto) { card.classList.add('is-playing'); vue(video); }
        video.addEventListener('play', function () { stopOthers(video); card.classList.add('is-playing'); });
        video.addEventListener('pause', function () { if (!auto) card.classList.remove('is-playing'); });
        card.addEventListener('click', function () {
          if (mode === 'none') return;
          if (mode === 'modal' && dialog) {
            // AMANI : on coupe les vignettes pendant la lecture en grand, toute la bande passante va à la vidéo ouverte
            enPause = videos.filter(function (v) { return !v.paused; }); enPause.forEach(function (v) { v.pause(); });
            if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
            self.undrShowAt(videos.indexOf(video));
            return;
          }
          if (auto) { video.muted = !video.muted; if (video.paused) video.play(); return; }
          if (video.paused) { video.muted = false; var p2 = video.play(); if (p2 && p2.catch) p2.catch(function () { video.muted = true; video.play(); }); }
          else video.pause();
        });
      });
    }
  }
  if (!customElements.get('undr-pdp-video-block')) customElements.define('undr-pdp-video-block', UndrPdpVideoBlock);
})();
